import { ReactNode } from "react";
import styles from "./InfoBar.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

export interface InfoBarProps {
  name: string;
  area: string | null;
  floor: string | null;
  ctaText: string;
  onCtaClick: () => void;
  showCta: boolean;
  icon?: ReactNode;
}

const MAX_NAME_LENGTH = 60;

const truncateName = (name: string): string => {
  if (name.length > MAX_NAME_LENGTH) {
    return `${name.slice(0, MAX_NAME_LENGTH)}...`;
  }
  return name;
};

const InfoBar = ({ name, area, floor, ctaText, onCtaClick, showCta, icon }: InfoBarProps) => (
  <div className={styles.infoBar} data-testid="floor-plans-info-bar">
    <div className={styles.metadata} data-testid="floor-plans-info-metadata">
      {icon && (
        <div className={styles.roomTypeIcon} aria-hidden="true">
          {icon}
        </div>
      )}
      <div key={name} className={`${styles.nameAndDetails} ${styles.infoFade}`}>
        <span
          className={styles.name}
          title={name.length > MAX_NAME_LENGTH ? name : undefined}
          data-testid="floor-plans-info-name"
        >
          {truncateName(name)}
        </span>
        <div className={styles.detailsRow} data-testid="floor-plans-info-details">
          {area && <span className={styles.detail}>{area}</span>}
          {area && floor && <span className={styles.detailDot} />}
          {floor && <span className={styles.detail}>{floor}</span>}
        </div>
      </div>
    </div>
    {showCta && (
      <button
        className={styles.ctaButton}
        onClick={onCtaClick}
        aria-label={ctaText}
        type="button"
        data-testid="floor-plans-view-room-cta"
      >
        {ctaText}
      </button>
    )}
  </div>
);

export default wrapperHOC(InfoBar, {
  componentName: "InfoBar-FloorPlansSection-PropertyPage",
  showForChina: true,
});
